// Module
var code = `<div id="modalInfo" class="modal hide fade" tabindex="-1" role="dialog" aria-labelledby="reportModalLabel" aria-hidden="true">
  <div class="modal-header">
    <h2 id="modalHeader">{{\$ctrl.title}}</h2>
  </div>
  <div class="modal-body">
    <span ng-if="\$ctrl.info">
        {{\$ctrl.info}}
    </span>
    <br ng-if="\$ctrl.info"/>
    <table class="table">
      <tr ng-repeat="row in \$ctrl.rows">
        <td ng-if="row.value" class="info-label">
          {{row.label}}&nbsp;:
        </td>
        <td ng-if="row.value" class="info-value">
          {{row.value}}
        </td>
      </tr>
    </table>
  </div>
  <div class="modal-footer">
    <div ng-repeat="b in \$ctrl.buttons" style="display:inline-block; margin-right:8px;">
      <button id="{{\$index+'button'}}" type="button" ng-click="b.action()" ng-class="b.bclass">
        {{b.text}}
      </button>
    </div>
    <button id="modalClose" class="btn" data-dismiss="modal" ng-click="\$ctrl.close()">Exit</button>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/modal/modal-info.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;